import $ from 'jquery';
import { $win, $body } from '../utils/globals';

function scrollTop() {
	let btn = $('.js-scroll-top');

	btn.on('click', function(e) {
		e.preventDefault();

		if ($body.hasClass('animating')) {
			return;
		}

		$body.addClass('animating');

		$('html, body').animate(
			{
				scrollTop: 0,
			},
			2000
		);

		setTimeout(function() {
			$body.removeClass('animating');
		}, 2000);
	});
}

export default scrollTop;
